import { termsStatusBadge } from './termsNotice';

/**
 * Spec 074 v2 — Signed / Not signed (text + colour, never colour alone). A garage signed through a delivered
 * email notice reads "Signed" with "via email notice" as a tooltip and as screen-reader text.
 * "—" before the backend sends a status.
 */
export default function TermsStatusBadge({ status, testId = 'terms-badge' }: { status?: string | null; testId?: string }) {
  if (!status) return <span className="signed-agreements-muted-inline">—</span>;
  const b = termsStatusBadge(status);
  return (
    <span className={`admin-badge ${b.cls}`} data-testid={testId} title={b.detail}>
      {b.label}
      {b.detail && <span className="signed-agreements-sr-only">{` (${b.detail})`}</span>}
    </span>
  );
}
